import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import requestsLongTermLease from 'app/requests/LongTermLease/LongTermLease.requests'

import {
    LongTermLeaseSelectorType,
} from '../longTermLease.types'

const useSelectorLongTermLease = (params: Record<string, any>, enabled: boolean) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<LongTermLeaseSelectorType[]>({
        key: RequestKeys.getSelectorLongTermLease,
        requestFunc: RequestFn.getEntity(
            requestsLongTermLease.selector, (promise) => {
                return promise.then((resp) => {
                    return resp?.data?.items
                })
            },
        ),
        params,
        enabled,
        staleTime: Infinity,
        keepPreviousData: true,
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useSelectorLongTermLease
